import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import RButton from "../../components/RButton";
import { BsArrowUpRight } from "react-icons/bs";
import { FaPlay } from "react-icons/fa";
import ValuesCard from "../../components/ValuesCard";
import FleetCard from "../../components/FleetCard";
import SlideCard from "../../components/SlideCard";
import "aos/dist/aos.css";
import axios from "axios";
import BottomBar from "../../components/BottomBar";
import BookingModal from "../../components/BookingModal";
import { GET_CAR_LIST } from "../../redux/type";
import { toast } from "react-toastify";
import { stringConstant, toast_options } from "../../utils/constants";
import { fms_fleet } from "../../utils/webAPIs";
import { FMS_BACKEND_URL } from "../../utils/config";
import { useSelector } from "react-redux";
import { FMS_MEDIA } from "../../utils/config";
import Hero from "../Components/Hero";
import RantCarToday from "../Components/RantCarToday";
import OurServices from "../Components/OurServices";
import HowItWorks from "../Components/HowItWorks";
import OurFleet from "../Components/OurFleet";
import TakeTour from "../Components/TakeTour";
import OurCoreValues from "../Components/OurCoreValues";
import DownloadApp from "../Components/DownloadApp";
import Subscribe from "../Components/Subscribe";
import HeroSection from "../Components/HeroSection";
const Home = () => {
  const [bookingModalVisible, setBookingModalVisible] = useState(false);
  const [carList, setCarList] = useState([]);
  const user = useSelector((state) => state.auth?.user);
  useEffect(() => {
    AOS.init();
    getFleetData();
  }, []);

  const getFleetData = () => {
    axios
      .get(`${FMS_BACKEND_URL}${fms_fleet}`)
      .then((res) => {
        // const { categories, vehicles } = res.data;
        // const result = categories.slice(0, 3).map((category) => ({
        //   ...category,
        //   vehicles: vehicles.filter(
        //     (vehicle) => vehicle.category === category.id
        //   ),
        // }));
        if (res.status === 200) {
          console.log(res);
          const { vehicleTypes, vehicles } = res.data.data;
          const result = [];
          vehicleTypes.map((category) => {
            // ...category,
            //       vehicles: vehicles.filter(
            //       (vehicle) => vehicle.type_id === category.id
            //   ),
            // if (result.length >= 3) return;
            const vehicle = vehicles.filter(
              (vehicle) => vehicle.type_id === category.id
            );
            if (vehicle.length > 0) {
              result.push({
                ...category,
                vehicles: vehicle,
              });
            }
          });
          console.log(result);
          setCarList(result);
        } else {
          toast.error(stringConstant.failed_register, toast_options);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <HeroSection />

      <div className="my-24 mt-48 sm:mt-24 md:mt-8">
        <RantCarToday />
      </div>

      <div data-aos="fade-up">
        <OurServices />
      </div>
      <div>
        <HowItWorks />
      </div>
      <div data-aos="fade-up">
        <OurFleet carList={carList} />
      </div>
      <div className="w-full mt-8 sm:-mt-16 md:-mt-32">
        <div className="relative top-12 sm:top-24 md:top-48 -z-10 ">
          <div className="w-full  ">
            <img src="image/home/slide_2.jpg" alt="" />
          </div>
        </div>
        <img src="image/home/discover_yoks.svg" alt="" className="w-full" />
      </div>
      <div className="-mt-12 sm:-mt-32 md:-mt-60 ">
        <div className="relative top-12 -z-50">
          <TakeTour />
        </div>
      </div>
      <div
        className="w-full h-max lg:h-[275px] overflow-hidden "
        style={{
          backgroundImage: "url('image/home/number_back.svg')",
        }}
      >
        <div className="max-w-[1280px] w-[90%] h-full grid grid-cols-1 md:grid-cols-2 items-center justify-center m-auto py-2">
          <div
            className=" text-white flex flex-wrap gap-2 md:block text-[28px] md:text-[35px] lg:text-[40px] font-semibold col-span-1"
            data-aos="fade-right"
          >
            <p>Showcase some</p>
            <p>impressive numbers.</p>
          </div>
          <div
            className="flex items-center justify-between col-span-1"
            data-aos="fade-left"
          >
            <div className="text-center text-white">
              <p className="text-[40px] font-semibold leading-tight">285</p>
              <p>vehicles</p>
            </div>
            <div className="text-center text-white">
              <p className="text-[40px] font-semibold leading-tight">200,000</p>
              <p>Miles</p>
            </div>
            <div className="text-center text-white">
              <p className="text-[40px] font-semibold leading-tight">13K</p>
              <p>Happy Customer</p>
            </div>
          </div>
        </div>
      </div>
      {/* <div className=" relative -z-10 -top-48"> */}
      <OurCoreValues />
      {/* </div> */}

      {/* <div className="w-full py-16 relative -z-10 -top-48"> */}
      <div className="w-[90%] max-w-[1280px] m-auto grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-36">
        <div
          className="flex flex-col items-start justify-start col-span-1 gap-6"
          data-aos="fade-up"
          data-duration="200"
        >
          <p className="text-[40px] font-semibold font-text">
            Hear what our amazing customers say
          </p>
          <p>
            Feel free to leave us a review we will be glad to hear about your
            experience with us
          </p>
          <Link
            to={user ? "#" : "/signup"}
            onClick={() => {
              if (user) {
                setBookingModalVisible(true);
              }
            }}
          >
            <RButton isradius={true}>
              <p className="flex items-center gap-4">
                <span>Get Started</span>
                <BsArrowUpRight />
              </p>
            </RButton>
          </Link>
        </div>
        <div
          className="flex flex-col col-span-1 gap-8"
          data-aos="fade-down"
          data-duration="200"
        >
          <div className="w-full ">
            <SlideCard />
          </div>
        </div>
      </div>
      {/* </div> */}
      <BookingModal
        visible={bookingModalVisible}
        setVisible={setBookingModalVisible}
      />
      {/* <div className="py-16 relative -z-10 -top-48"> */}
      <DownloadApp />
      {/* </div>
      <div className="py-16 relative -z-10 -top-96"> */}
      <Subscribe />
      {/* </div> */}
    </>
  );
};

export default Home;
